import React from 'react';

import {isAdminPage} from 'Services/BaseHelpers';

/**
 * @function ModalBody
 * @param {object} props
 * @return {JSX.Element}
 * @constructor
 */
const ModalBody = (props) => {
    let classNames = `
        px-4 py-5 sm:p-6
        ${isAdminPage() ? null : 'bg-app-yellow m-3 rounded-b-lg'}
    `;

    return (
        <div className={classNames}>
            {props.children}
        </div>
    );
};


export default ModalBody;
